import parseJSONP from "../utils/parseJSONP";

const GUID = process.env.ABR_TOKEN || "4f94b581-a15b-4345-967c-b349343a23e6";

const abrFetch = async (path, params) => {
  const query = new URLSearchParams({ guid: GUID, ...params });
  const response = await fetch(`https://abr.business.gov.au/json/${path}?${query.toString()}`, {
    method: "GET",
  });
  if (!response.ok) {
    throw new Error(`ABR request failed with status ${response.status}`);
  }
  return response.text();
};

export async function getBusinessByABN(searchTerm) {
  try {
    const body = await abrFetch("AbnDetails.aspx", { abn: searchTerm });
    return parseJSONP(body);
  } catch (error) {
    console.error(error);
  }
}

export async function getBusinessByACN(searchTerm) {
  try {
    const body = await abrFetch("AcnDetails.aspx", { acn: searchTerm });
    return parseJSONP(body);
  } catch (error) {
    console.error(error);
  }
}

export async function getBusinessByName(searchTerm) {
  try {
    const body = await abrFetch("MatchingNames.aspx", { name: searchTerm });
    return parseJSONP(body);
  } catch (error) {
    console.error(error);
  }
}
